const NAME = "CONCEPTS_AND_FORMULAS";

export default NAME;
